import { render, staticRenderFns } from "./Pax.vue?vue&type=template&id=351048cc&"
import script from "./Pax.vue?vue&type=script&lang=js&"
export * from "./Pax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports